import cx from 'classnames';
import { StarIcon } from '@heroicons/react/20/solid';

interface RatingProps {
  stars: number;
  maxStars?: number;
  showNumber?: boolean;
  className?: string;
}

export const Rating: React.FC<RatingProps> = ({
  stars,
  maxStars = 5,
  showNumber = false,
  className = '',
}) => (
  <span>
    {Array(maxStars)
      .fill(0)
      .map((_, index) => (
        <StarIcon
          key={index}
          className={cx(
            // Round average to a single decimal place before flooring to get the number of stars
            index < Math.round(stars) ? 'text-yellow-400' : 'text-gray-300',
            'w-4 inline',
            className,
          )}
        />
      ))}
    {showNumber && <span className="text-xs ml-2">{stars.toFixed(1)}</span>}
  </span>
);
